import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const UPDATE_REQUEST = 'realhub/agencyProviderPackage/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/agencyProviderPackage/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/agencyProviderPackage/UPDATE_FAILURE'

// Initial State
const initialState = {
  updating: false,
  errors: [],
}

// Actions
export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function bulkUpdateIds(providerPackage, agencyIds, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      agency: agencyIds,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/provider_packages/${providerPackage.id}/update_permissions.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Clear existing permissions
        const state = getState()
        const agencyProviderPackages = state.entities.agencyProviderPackages
        const keys = Object.keys(agencyProviderPackages)
        keys.forEach((key) => {
          const object = agencyProviderPackages[key]
          if (object && object.provider_package_id === providerPackage.id){
            const normalized = normalize(object, Schemas.AGENCY_PROVIDER_PACKAGE)
            dispatch(deleteEntity(normalized))
          }
        })

        const normalizedJson = normalize(json, Schemas.AGENCY_PROVIDER_PACKAGE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
